import { yupMobileNumber } from "@utils/yup";
import { useTranslation } from "react-i18next";
import { string, object } from 'yup';

export const useValidationSchema = () => {
  const { t } = useTranslation();
  return object({
    mobileNumber: yupMobileNumber(),
    otpCode: string().required(t('validation:required')).length(4, t('validation:length')),
  })
}
